import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminApi } from '../api/admin';
import { format } from 'date-fns';
import './TablePage.css';

const STATUS_LABELS: Record<string, string> = {
  pending: '대기중',
  delivered: '전달됨',
  viewed: '확인함',
  guessed: '픽 완료',
  awaiting_result: '결과대기',
  matched: '매칭성공',
  failed: '매칭실패',
  expired: '만료',
};

export default function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) adminApi.getUserDetail(id).then(setUser).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">로딩 중...</div>;
  if (!user) return <div className="loading">유저를 찾을 수 없습니다</div>;

  return (
    <div className="table-page">
      <button className="back-btn" onClick={() => navigate('/users')}>← 유저 목록</button>
      <div className="detail-header">
        <h2>{user.phone}</h2>
        <span className={`badge ${user.isOnboarded ? 'green' : 'gray'}`}>
          {user.isOnboarded ? '온보딩 완료' : '온보딩 미완료'}
        </span>
      </div>
      <div className="detail-info">
        <div><strong>ID:</strong> {user.id}</div>
        <div><strong>가입일:</strong> {format(new Date(user.createdAt), 'yyyy-MM-dd HH:mm')}</div>
        {user.kakaoEnabled && user.kakaoId && <div><strong>카카오 ID:</strong> {user.kakaoId}</div>}
        {user.protectedUntil && new Date(user.protectedUntil) > new Date() && (
          <div><strong>보호기간:</strong> ~{format(new Date(user.protectedUntil), 'yyyy-MM-dd')}</div>
        )}
      </div>

      <h3>보낸 픽 ({user.sentPicks?.length || 0})</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr><th>대상</th><th>힌트</th><th>상태</th><th>생성일</th></tr>
          </thead>
          <tbody>
            {(user.sentPicks || []).map((p: any) => (
              <tr key={p.id} className="clickable" onClick={() => navigate(`/picks/${p.id}`)}>
                <td>{p.pickedContactName}</td>
                <td>{p.hintText}</td>
                <td><span className={`badge ${p.status}`}>{STATUS_LABELS[p.status] || p.status}</span></td>
                <td>{format(new Date(p.createdAt), 'yyyy-MM-dd')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3>받은 픽 ({user.receivedPicks?.length || 0})</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr><th>힌트</th><th>상태</th><th>생성일</th></tr>
          </thead>
          <tbody>
            {(user.receivedPicks || []).map((p: any) => (
              <tr key={p.id} className="clickable" onClick={() => navigate(`/picks/${p.id}`)}>
                <td>{p.hintText}</td>
                <td><span className={`badge ${p.status}`}>{STATUS_LABELS[p.status] || p.status}</span></td>
                <td>{format(new Date(p.createdAt), 'yyyy-MM-dd')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
